const i18nConfig = {
  "请选择": "请选择",
  "正在加载...": "正在加载...",
  "获取表单失败，请检查网络": "获取表单失败，请检查网络。",
  "表单": "表单",
  "paas.smart.form.submit": "表单提交...",
  "提交成功": "提交成功",
  "支付二维码": "支付二维码",
  "关闭": "关闭",
  "付款成功": "付款成功",
  "验证码": "验证码",
  "不再提示": "不再提示",
  "手机浏览器只能提交表单，无法进行支付": "手机浏览器只能提交表单，无法进行支付",
  "取消": "取消",
  "确定": "确定",
  "提交并支付": "提交并支付",
  "请输入": "请输入",
  "paas.smart.form.isrequired": "该项是必填项",
  "格式不正确": "格式不正确",
  "不能为空": "不能为空",
  "手机号格式不正确": "手机号格式不正确",
  "paas.select.location": "请选择定位",
  "签到成功": "签到成功",
  "表单提交成功": "表单提交成功",
  "请输入多选备注": "请输入多选备注",
  "上传失败": "上传失败",
  "重传": "重传",
  "超过文件大小限制": "超过文件大小限制",
  "上传附件": "上传附件",
  "该图片已在列表中": "该图片已在列表中",
  "超过图片大小限制": "超过图片大小限制",
  "图形验证码": "图形验证码",
  "验证码输入不正确": "验证码输入不正确",
  "请输入验证码": "请输入验证码",
  "验证码是必填项": "验证码是必填项",
  "paas.incorrect.verification.input": "验证输入不正确!",
  "请输入写字楼街道公司名称": "请输入写字楼、街道、公司名称",
  "重新定位": "重新定位",
  "选择定位": "选择定位",
  "ava.objdetail.eservice.workorderSign.loadingLoaction": "定位中...",
  "定位失败": "定位失败",
  "公司企业|商务住宅|政府机构及社会团体": "公司企业|商务住宅|政府机构及社会团体",
  "搜索附近地址": "搜索附近地址",
  "附近地址": "附近地址",
  "正在上传签名，请稍后提交": "正在上传签名，请稍后提交",
  "签名": "签名",
  "上传签名失败": "上传签名失败",
  "选择日期": "选择日期",
  "选择时间": "选择时间",
  "请输入单选备注": "请输入单选备注",
  "元": "元",
  "万": "万",
  "亿": "亿",
  "paas.omen": "兆",
  "拾": "拾",
  "佰": "佰",
  "仟": "仟",
  "壹": "壹",
  "贰": "贰",
  "叁": "叁",
  "肆": "肆",
  "伍": "伍",
  "陆": "陆",
  "柒": "柒",
  "捌": "捌",
  "玖": "玖",
  "角": "角",
  "分": "分",
  "整": "整"
}
export default i18nConfig



// WEBPACK FOOTER //
// ./src/assets/i18n.js